<template>
	<inertia-head title="Investor Zoom Events" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Investor Zoom Events</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">Investor Zoom Events Management List</h2>
				</div>
			</div>
		</div>
	</div>

	<div class="content">
		<div class="block border-bottom">
			<div class="block-content">
				<form @submit.prevent="searchEvents">
					<div class="row">
						<div class="col-md-10 mb-4">
							<div class="input-group">
								<input v-model="form.search" type="text" id="search" name="search" class="form-control" placeholder="Search" />
								<span class="input-group-btn">
									<button
										type="submit"
										class="btn btn-secondary"
										:disabled="!form.isDirty || form.processing"
									>
										<i class="fa fa-search me-1"></i>Display
									</button>
								</span>
							</div>
						</div>
						<div class="col space-x-1 mb-4 text-end">
							<button
								@click="addEvent"
								type="button"
								class="btn btn-info"
							>
								<i class="fa fa-plus me-1"></i>Add
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
		<pagination :collections="events" />
		<div v-for="(event,e_index) in events.data" class="block mb-1">
			<div class="block-content block-content-full">
				<div class="row">
					<div class="col-md-3">
						<img :src="event.investor_zoom_img_url??'/media/images/event_image.jpeg'" style="width:100%"/>
					</div>
					<div class="col-md-9">
						<p class="m-0"><span class="fw-bold">{{event.investor_zoom_topic}}</span></p>
						<div class="fs-sm fw-normal text-muted mb-2">
							<div class="form-check form-switch form-check-inline">
								<input
									class="form-check-input"
									type="checkbox"
									:value="event.is_active"
									:id="event.id"
									name="example-switch-inline1"
									:checked="event.is_active"
									@change="toggleStatus(event.investor_zoom_event_uuid,event.is_active)"
								/>
								<label class="form-check-label fw-semibold" :for="event.id">
									{{ event.is_active ? 'ACTIVE' : 'IN-ACTIVE' }}
								</label>
							</div>
						</div>
						<div class="mt-5">
							<p class="fw-bold mb-1">Available Dates <button @click="selectAddEventDate(e_index)" type="button" class="btn btn-xs btn-info float-end"><i class="fa fa-plus me-1"></i>Add Date</button></p>
							<div class="table-responsive" style="max-height: 275px;">
								<table class="table fs-sm">
									<thead>
										<tr>
											<th>Attendees</th>
											<th>Start Date</th>
											<th>End Date</th>
											<th>Capacity</th>
											<th class="text-end">::::</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(edate,ed_index) in event.event_dates">
											<td>{{edate.attendees}}</td>
											<td>{{edate.start_date}} {{edate.start_time}}</td>
											<td>{{edate.end_date}} {{edate.end_time}}</td>
											<td>{{edate.zoom_capacity}}</td>
											<td class="text-end">
												<button @click="selectUpdateEventDate(e_index,ed_index)" type="button" class="btn btn-xs btn-info ms-1 mb-1"><i class="fa fa-edit"></i></button>
												<button @click="selectDeleteEventDate(e_index,ed_index)" type="button" class="btn btn-xs btn-danger ms-1 mb-1"><i class="fa fa-trash"></i></button>
												<a v-if="['thibz','ian'].includes($page.props.user.fname)" :href="'/admin/investor-zoom/events/'+event.investor_zoom_event_uuid+'/attendees/'+edate.investor_zoom_date_uuid+'/send/gr-campaign'" target="_blank" class="btn btn-xs btn-warning ms-1 mb-1"><i class="fa fa-envelope"></i></a>
											</td>
										</tr>
										<tr v-if="event.event_dates.length<=0">
											<td colspan="5" class="text-center fw-bold text-muted">No Dates Available</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="block-content block-content-full block-content-sm bg-body-light fs-sm space-x-1">
				<button @click="updateEvent(e_index)" type="button" class="btn btn-outline-info btn-sm"><i class="fa fa-edit me-1"></i>Edit</button>
				<button @click="selectDeleteEvent(event.investor_zoom_event_uuid)" type="button" class="btn btn-outline-danger btn-sm"><i class="fa fa-times me-1"></i>Delete</button>
				<button @click="viewAttendees(event.investor_zoom_event_uuid)" type="button" class="btn btn-outline-success btn-sm"><i class="fa fa-users me-1"></i>Attendees({{event.attendees}})</button>
			</div>
		</div>
		<div v-if="events.data.length==0" class="block mb-1">
			<div class="block-content block-content-full">
				<h1 class="text-center text-danger">No Investor Zoom Event Found</h1>
			</div>
		</div>
		<div class="mt-3">
			<pagination :collections="events" />
		</div>
	</div>


	<modal ref="addUpdateEventDateModal" size="modal-md">
		<template #title>
			{{event_date_action.toUpperCase()}} DATE CONTENT
		</template>
		<template #body>
			<div class="form-floating mb-4">
				<input type="text" v-model="formEventDate.zoom_meeting_id" id="zoom_meeting_id" name="zoom_meeting_id" class="form-control" placeholder="Zoom Meeting ID" />
				<label class="form-label" for="zoom_meeting_id">Zoom Meeting ID</label>
			</div>
			<div class="form-floating mb-4">
				<input type="text" v-model="formEventDate.zoom_passcode" id="zoom_passcode" name="zoom_passcode" class="form-control" placeholder="Zoom Passcode" />
				<label class="form-label" for="zoom_passcode">Zoom Passcode</label>
			</div>
			<div class="form-floating mb-4">
				<input type="text" v-model="formEventDate.zoom_access_url" id="zoom_access_url" name="zoom_access_url" class="form-control" placeholder="Zoom URL" />
				<label class="form-label" for="zoom_access_url">Zoom URL</label>
			</div>
			<div class="form-floating mb-4">
				<flat-pickr
					v-model="formEventDate.start_datetime"
					:config="{
						enableTime: true,
						altInput: true,
						altFormat: 'M j, Y h:i K',
						dateFormat: 'Y-m-d H:i:s',
					}"
					class="form-control"
					:class="
						formEventDate.errors.start_datetime
							? 'flatpickr-input is-invalid border-danger'
							: 'flatpickr-input'
					"
				/>
				<label class="form-label" for="start_datetime">Start DateTime</label>
			</div>
			<div class="form-floating mb-4">
				<flat-pickr
					v-model="formEventDate.end_datetime"
					:config="{
						enableTime: true,
						altInput: true,
						altFormat: 'M j, Y h:i K',
						dateFormat: 'Y-m-d H:i:s',
					}"
					class="form-control"
					:class="
						formEventDate.errors.end_datetime
							? 'flatpickr-input is-invalid border-danger'
							: 'flatpickr-input'
					"
				/>
				<label class="form-label" for="end_datetime">End DateTime</label>
			</div>
			<div class="form-floating mb-4">
				<input type="number" v-model="formEventDate.zoom_capacity" id="zoom_capacity" name="zoom_capacity" class="form-control" placeholder="Speaker Name" min="50" />
				<label class="form-label" for="zoom_capacity">Zoom Capacity</label>
			</div>
		</template>
		<template #footer>
			<button 
				@click="actionEventDateContent"
				type="submit"
				class="btn btn-alt-primary"
				:disabled="formEventDate.processing || !formEventDate.isDirty"
			>
				<span v-if="!formEventDate.processing"><i class="fa fa-save me-2"></i><span v-if="event_date_action=='add'">Add</span><span v-else>Update</span></span>
					<span v-else>
						<div class="spinner-border spinner-border-sm text-dark" role="status" >
							<span class="sr-only mr-1">Please wait...</span>
						</div>
						<span class="mx-2">Please wait...</span>
					</span>
			</button>
			<button type="button" class="btn btn-sm btn-secondary" @click="addUpdateEventDateModal.toggleModal()"><i class="fa fa-times"></i> Cancel</button>
		</template>
	</modal>



	<modal ref="confirmDeleteEventDateModal" size="modal-md">
		<template #title>
			Delete Confirmation
		</template>
		<template #body>
			<div class="mb-4">
				<p class="h5">Are you sure, you want to delete this details?</p>
			</div>
		</template>
		<template #footer>
			<button @click="deleteEventDate" type="button" class="btn btn-sm btn-danger"><i class="fa fa-trash"></i> Delete</button>
			<button type="button" class="btn btn-sm btn-secondary" @click="confirmDeleteEventDateModal.toggleModal()"><i class="fa fa-times"></i> Cancel</button>
		</template>
	</modal>

	<modal ref="deleteModal" size="modal-md">
		<template #title>
			Delete Confirmation
		</template>
		<template #body>
			<div class="mb-4">
				<p class="h5">Are you sure, you want to delete this details?</p>
			</div>
		</template>
		<template #footer>
			<button @click="confirmDeleteEvent" type="button" class="btn btn-sm btn-danger"><i class="fa fa-trash"></i> Delete</button>
			<button type="button" class="btn btn-sm btn-secondary" @click="deleteModal.toggleModal()"><i class="fa fa-times"></i> Cancel</button>
		</template>
	</modal>

	<AddUpdateInvestorZoomEventModal
			key="EventModal"
			ref="addUpdateInvestorZoomEventModal"
		/>

</template>

<script>
	import { onMounted, watch, ref, reactive } from 'vue';
	import { useForm } from '@inertiajs/inertia-vue3';
	import AuthLayout from '../../../Layouts/AuthLayout';
	import { createToaster } from '@meforma/vue-toaster';
	import { Inertia } from '@inertiajs/inertia';
	import AddUpdateInvestorZoomEventModal from '../../../Components/Admin/AddUpdateInvestorZoomEventModal'

	export default{
		layout: AuthLayout,
		props: {
			events				: Object,
			filter				: String,
			search				: String,
			errors				: Object,
			api_response 		: Object,
			flash				: Object
		},
		components:{AddUpdateInvestorZoomEventModal},
		setup(props){

			const addUpdateEventDateModal 		= ref(null);
			const confirmDeleteEventDateModal 	= ref(null);

			const deleteModal = ref(null);

			const selected_index = ref(null);

			const selected_event_uuid = ref(null);

			const toast = createToaster();

			const action 			= ref('add');
			const event_date_action = ref('add');

			const formEventDate = useForm({
				investor_zoom_event_uuid 	:null,
				investor_zoom_date_uuid 	:null,
				zoom_meeting_id 			:null,
				zoom_passcode 				:null,
				zoom_access_url 			:null,
				start_datetime 				:'',
				end_datetime 				:'',
				zoom_capacity 				: 500,
			});

			const form = useForm({
				filter 		: props.filter,
				search 		: props.search,
				is_active 	: 0,
			})

			const addUpdateInvestorZoomEventModal = ref(null);

			const searchEvents = () => {

				Inertia.get(route('admin.investor-zoom-events',{
						search 		: form.search
					})
				)
			}


			const toggleStatus = (_event_uuid,is_active)=>{
				action.value = "update";
				form.is_active = (is_active==1) ? 0 : 1;
				form.put('events/status/'+_event_uuid, {
					preserveState: true,
					preserveScroll: true,
					only:['events,api_response'],
				})
			}

			const addEvent = ()=>{

				action.value = "add";
				addUpdateInvestorZoomEventModal.value.setInvestorZoomEventContent(action.value,null);
				addUpdateInvestorZoomEventModal.value.toggleModal();
			}

			const updateEvent = (_index)=>{

				action.value = "update";

				addUpdateInvestorZoomEventModal.value.setInvestorZoomEventContent(action.value,props.events.data[_index]);

				addUpdateInvestorZoomEventModal.value.toggleModal();
			}

			const selectAddEventDate = (_index)=>{

				event_date_action.value 				= "add";
				
				formEventDate.investor_zoom_event_uuid 	= props.events.data[_index].investor_zoom_event_uuid;

				addUpdateEventDateModal.value.toggleModal();
			}

			const selectUpdateEventDate = (_index,_index1)=>{

				event_date_action.value 				= "update";
				
				formEventDate.investor_zoom_event_uuid 	= props.events.data[_index].investor_zoom_event_uuid;
				formEventDate.investor_zoom_date_uuid 	= props.events.data[_index].event_dates[_index1].investor_zoom_date_uuid;
				formEventDate.zoom_meeting_id 			= props.events.data[_index].event_dates[_index1].zoom_meeting_id;
				formEventDate.zoom_passcode 			= props.events.data[_index].event_dates[_index1].zoom_passcode;
				formEventDate.zoom_access_url 			= props.events.data[_index].event_dates[_index1].zoom_access_url;
				formEventDate.start_datetime 			= props.events.data[_index].event_dates[_index1].start_datetime;
				formEventDate.end_datetime 				= props.events.data[_index].event_dates[_index1].end_datetime;
				formEventDate.zoom_capacity 			= props.events.data[_index].event_dates[_index1].zoom_capacity;

				addUpdateEventDateModal.value.toggleModal();
			}

			const selectDeleteEventDate = (_index,_index1)=>{

				action.value 							= "";
				event_date_action.value 				= "delete";
									
				formEventDate.investor_zoom_date_uuid 	= props.events.data[_index].event_dates[_index1].investor_zoom_date_uuid;

				confirmDeleteEventDateModal.value.toggleModal();

			}

			const selectDeleteEvent = (_event_uuid)=>{
				selected_event_uuid.value = _event_uuid;
				deleteModal.value.toggleModal();
			}

			const confirmDeleteEvent = ()=>{
				deleteEvent(selected_event_uuid.value);
			}

			const viewAttendees = (_event_uuid)=>{
				Inertia.get("events/attendees/"+_event_uuid);
			}

			const deleteEvent = (_event_uuid) => {
				action.value = "delete";
				Inertia.delete('events/'+_event_uuid,
				{
					preserveState: true,
					preserveScroll: true,
					only:['events','api_response'],
					onSuccess:()=> {
						selected_event_uuid.value = null;
						deleteModal.value.toggleModal();
					}
				})
			}


			const actionEventDateContent = ()=>{

				action.value = "";
				if(event_date_action.value=='add')
				{
					addEventDate();
				}else{
					updateEventDate();
				}
			}


			const addEventDate = ()=>{

				formEventDate.post(route('admin.post.investor-zoom-events-date'), {
					preserveState: true,
					preserveScroll: true,
					only:['events','api_response'],
					onSuccess: () => {
						formEventDate.reset();
						addUpdateEventDateModal.value.toggleModal();
					},
				})

			}

			const updateEventDate = ()=>{
				formEventDate.put('events/date/'+formEventDate.investor_zoom_date_uuid, {
					preserveState: true,
					preserveScroll: true,
					only:['events','api_response'],
					onSuccess: () => {
						formEventDate.reset();
						addUpdateEventDateModal.value.toggleModal();
					},
				})
			}


			const deleteEventDate = ()=>{
				formEventDate.delete('events/date/'+formEventDate.investor_zoom_date_uuid, {
					preserveState: true,
					preserveScroll: true,
					only:['events','api_response'],
					onSuccess: () => {
						formEventDate.reset();
						confirmDeleteEventDateModal.value.toggleModal();
					},
				})
			}


			watch(()=>props.api_response, (value) => {
			
				if(value!=null)
				{

					let action_msg = ""

					if(action.value!='')
					{
						action_msg = action.value=='add'?'added':(action.value=='update'?'updated':'deleted'); 
					}else{
						action_msg = event_date_action.value=='add'?'added':(event_date_action.value=='update'?'updated':'deleted'); 

					}
					

					if(value.result=="success")
					{
						toast.show("Successfully "+action_msg, { type: value.result});
					}else
					{
						toast.show("Failed to process. "+value.data, { type: "error"});
					}
				}
			})


			return{
				selected_index,
				formEventDate,
				selected_event_uuid,
				selectDeleteEvent,
				addUpdateEventDateModal,
				confirmDeleteEventDateModal,
				deleteModal,
				confirmDeleteEvent,
				toast,
				action,
				event_date_action,
				form,
				toggleStatus,
				searchEvents,
				addUpdateInvestorZoomEventModal,
				addEvent,
				updateEvent,
				deleteEvent,
				viewAttendees,
				selectAddEventDate,
				selectUpdateEventDate,
				selectDeleteEventDate,
				actionEventDateContent,
				addEventDate,
				updateEventDate,
				deleteEventDate,
			}

		}
	}

</script>